import PDFViewer from './PDFViewer'

const PDFViewerManager = {
  init: function () {
    const container = document.getElementById('PDFViewer')
    if (!container) return

    PDFViewer.init()

    const pdfLinks = document.querySelectorAll('.js-pdfviewer-links')
    pdfLinks.forEach((link) => {
      link.addEventListener('click', (e) => {
        container.innerHTML = ''
        container.setAttribute('data-source', link.getAttribute('data-source'))

        PDFViewer.init()
      })
    })

    const alert = document.querySelector('.js-pdfviewer-alert')
    if (alert && (document.documentMode || /Edge/.test(navigator.userAgent))) {
      alert.classList.remove('u-d-none')
    }
  }
}

export default PDFViewerManager



// WEBPACK FOOTER //
// app/javascript/scripts/components/PDFViewerManager.js